'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
var singleton = exports.singleton = Symbol.for('dmInstance');
var singletonEnforcer = Symbol.for('enforcing');

var DebugManager = function () {
  function DebugManager(enforcer) {
    _classCallCheck(this, DebugManager);

    if (enforcer !== singletonEnforcer) {
      throw new Error('Cannot construct a singleton');
    }
    this._debug = null;
    this.logList = [];
  }

  _createClass(DebugManager, [{
    key: 'processLogQueue',
    value: function processLogQueue() {
      var _this = this;

      this.logList.forEach(function (item) {
        _this.logMessage.apply(_this, [item.levels].concat(_toConsumableArray(item.rest)));
      });
    }

    /**
     * Takes an array of debug options and any number of additional arguments
     * and logs to console - dependant on debug param
     *
     * @param {Array} levels array of debug options to match with query param
     * @param {Array} rest array of content to be written out to console
     *
     */

  }, {
    key: 'logMessage',
    value: function logMessage(levels) {
      var _this2 = this;

      for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      // no query param on url - let's exit
      if (this.debug && !this.debug.length) return null;

      // debug param hasn't been read in yet, store messages in a queue
      if (this.debug === null) {
        this.logList.push({ levels: levels, rest: rest });
        return null;
      }

      levels.forEach(function (level) {
        if (_this2.debug.includes(level)) {
          var _DebugManager$dmInsta;

          return (_DebugManager$dmInsta = DebugManager.dmInstance).log.apply(_DebugManager$dmInsta, rest);
        }
        return null;
      });
      return null;
    }

    // writes out log message to console with UTC timestamp prepended

  }, {
    key: 'log',
    value: function log() {
      var _console;

      for (var _len2 = arguments.length, message = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        message[_key2] = arguments[_key2];
      }

      return (_console = console).log.apply(_console, _toConsumableArray(['[' + new Date().toISOString().slice(11, -5) + ']'].concat(Array.prototype.slice.call(message))));
    }
  }, {
    key: 'debug',
    set: function set(val) {
      // no query param on url. empty queue and exit
      if (val === '') {
        this._debug = [];
        this.logList = [];
        return;
      }
      this._debug = val.split(',');
      this.processLogQueue();
    },
    get: function get() {
      return this._debug;
    }
  }], [{
    key: 'dmInstance',
    get: function get() {
      if (!DebugManager[singleton]) {
        DebugManager[singleton] = new DebugManager(singletonEnforcer);
      }

      return DebugManager[singleton];
    }
  }]);

  return DebugManager;
}();

DebugManager.debugLevel = {
  A: 'A', // React redux actions
  B: 'B', // Inband events
  C: 'C', // Component Events
  F: 'F', // Failover
  M: 'M', // Video Player (includes Standard, Hive, MS eCDN, and RAMP )
  V: 'V', // VTT Processing
  R: 'R', // Audience Resize
  PUMP: 'p', // Event Pump
  W: 'W', // workspace
  WS: 'WS', // websocket
  COMPONENT_SLIDESHOW: 'c_slide'
};
exports.default = DebugManager;